var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"bg"}},[(_vm.show.other !== '')?_c('div',{staticClass:"bg-box"},[_c('div',{staticClass:"main-bg",on:{"click":_vm.display}}),_c('comp-account'),_c('comp-workspace')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }